import styled, { css } from 'styled-components';

import { Box as ComponentBox } from '@/components/Box';
import { Button } from '@/components/Button';
import { Flex } from '@/components/Flex';
import { LegacyButton } from '@/components/LegacyButton';
import { px2rem } from '@/theme';
interface HitsWrapperProps {
  itemCount: number;
}

interface ComparisonButtonProps {
  isUnderLargeBreakpoint?: boolean;
}

export const Containers = styled(ComponentBox)`
  overflow-x: hidden;
`;
export const WishlistWrapper = styled(Flex)`
  display: flex;
  flex-direction: row;
  ${({ theme }) => css`
    padding: ${theme.spacing(0, 2)};
    @media (min-width: ${theme.breakpoints.sm}) {
      margin-bottom: ${theme.spacing(1.5)};
    }
  `}
`;
export const HitsWrapper = styled(Flex)<HitsWrapperProps>`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: stretch;
  justify-content: center;
  gap: 10px;
  width: 100%;
  max-width: 1100px;
  ${({ itemCount, theme }) => css`
    @media (min-width: ${theme.breakpoints.sm}) {
      width: 100%;
      gap: 20px;
    }
    @media (min-width: ${theme.breakpoints.lg}) {
      justify-content: ${itemCount > 4 ? 'flex-start' : 'center'};
    }
  `}
`;
export const ProductContainer = styled.div`
  width: calc(43vw + 1px);
  max-width: 250px;
  ${({ theme }) => css`
    background-color: ${theme.colors.secondaryLightGrey};
    @media (min-width: ${theme.breakpoints.md}) {
      width: calc(25vw + 1px);
    }
  `}
`;
export const Wishlist = styled(Flex)`
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: ${({ theme }) => theme.spacing(8, 0)};
`;

export const EmptyContainer = styled(Flex)`
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: ${({ theme }) => theme.spacing(8, 0)};
`;

export const Prompt = styled.h2`
  margin-bottom: 20px;
  text-align: center;
  text-transform: uppercase;
  ${({ theme }) => css`
    color: ${theme.colors.black};
    margin-top: ${theme.spacing(8)};
    font-weight: ${theme.fontWeights.bold};
    font-family: ${theme.fontFamilies.italianPlate};
    font-size: ${theme.fontSizes.h3};
  `}
`;
export const HeaderWrapper = styled(Flex)`
  justify-content: center;
  flex-wrap: wrap;

  ${({ theme }) => css`
    gap: ${theme.spacing(2)};
    margin: ${theme.spacing(4, 0)};
  `};
`;

export const ContextBox = styled.div`
  width: 462px;
  flex-decoration: row;
  text-align: center;
  ${({ theme }) => css`
    margin-top: ${theme.spacing(1)};
  `}
`;
export const TextUnderLine = styled.span`
  text-decoration: underline;
  white-space: nowrap;
  cursor: pointer;
  font-weight: bold;
  ${({ theme }) => css`
    color: ${theme.colors.black};
    font-family: ${theme.fontFamilies.openSans};
    font-size: ${theme.fontSizes.p2};
  `}
`;

export const Text = styled.p`
  ${({ theme }) => css`
    padding: 0 10px;
    text-align: center;
    margin-bottom: 5px;
    color: ${theme.colors.black};
    font-family: ${theme.fontFamilies.openSans};
    font-size: ${theme.fontSizes.p2};
  `}
`;

export const SubmitButton = styled(Button)`
  width: 250px;
  text-align: center;
  ${({ theme }) => css`
    padding: 16px 0;
    color: ${theme.colors.black};
    font-family: ${theme.fontFamilies.openSans};
    font-size: ${theme.fontSizes.p2};
  `}
`;
export const TextOr = styled.span`
  ${({ theme }) => css`
    color: ${theme.colors.black};
    font-family: ${theme.fontFamilies.openSans};
    font-size: ${theme.fontSizes.p2};
    margin: ${theme.spacing(0.5)};
  `}
`;
export const Box = styled(Flex)`
  margin-bottom: 20px;
  flex-direction: column;
  align-items: center;
`;
export const ContinueShoppingButton = styled(LegacyButton)`
  margin-top: 20px;
  margin-bottom: 50px;
  width: 100%;
  text-decoration: none;

  ${({ theme }) => css`
    color: ${theme.colors.black};

    ${theme.media.md.up} {
      width: 250px;
    }
  `}
`;
export const submitButton = styled(Button)`
  margin-top: 20px;
  width: 250px;
  text-align: center;
  &:first-child {
    margin-bottom: ${({ theme }) => theme.spacing(2)};
  }
  &:last-child {
    border: 2px solid ${({ theme }) => theme.colors.primary};
  }

  ${({ theme }) => css`
    padding: 16px 0;
    color: ${theme.colors.black};
    font-family: ${theme.fontFamilies.openSans};
    font-size: ${theme.fontSizes.p2};
  `}
`;

export const ButtonBox = styled(Flex)`
  ${({ theme }) => css`
    margin-top: ${theme.spacing(4)};
  `}
`;

export const AddressWrapper = styled(Flex)`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  overflow: hidden;
  overflow-x: scroll;
  max-width: 100vw;
  ${({ theme }) => css`
    padding: ${theme.spacing(0, 2)};
    @media (min-width: ${theme.breakpoints.sm}) {
      flex-wrap: nowrap;
      overflow: hidden;
      overflow-x: scroll;
    }
  `}
`;

export const SelectedWrapper = styled.header`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px -3px 6px #0000001c;
  ${({
    theme: {
      colors,
      components: {
        header: { breakpoint },
      },
      zIndex,
    },
  }) => css`
    background-color: ${colors.white};
    z-index: ${zIndex.sideDrawer};
    margin: 0 auto;

    @media (max-width: ${breakpoint}) {
      margin: initial;
    }
  `}
`;

export const InnerWrapperBox = styled.div`
  display: grid;
  grid-template-columns: 115px 1fr 1fr;
  width: 100%;
  padding: ${px2rem(12)};
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  ${({ theme }) => css`
    max-width: ${theme.components.header.innerWrapper.maxWidth};

    @media (max-width: ${theme.components.header.breakpoint}) {
      grid-template-columns: auto 1fr;
    }
    @media (min-width: ${theme.breakpoints.lg}) {
      width: 1100px;
    }
  `}
`;
export const CompareCheckbox = styled(Flex)`
  ${({ theme }) => css`
    margin-top: ${theme.spacing(2)};
  `}
`;
export const WatchBox = styled.div`
  border-radius: 999px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-align: center;
  ${({ theme }) => css`
    width: ${theme.fontSizes.h2Mobile};
    height: ${theme.fontSizes.h2Mobile};
    font-size: ${theme.fontSizes.h5};
    font-family: ${theme.fontFamilies.italianPlate};
    font-weight: ${theme.fontWeights.bold};
    background: ${theme.colors.primary};
  `}
`;
export const WatchLabel = styled.div`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.p2};
    font-family: ${theme.fontFamilies.openSans};
    font-weight: ${theme.fontWeights.regular};
    margin-left: ${theme.spacing(1)};
  `}
`;

export const ComparisonButton = styled(Button)<ComparisonButtonProps>`
  width: 100%;
  text-align: center;
  text-transform: uppercase;
  ${({ isUnderLargeBreakpoint, theme }) => css`
    font-size: ${theme.fontSizes.p2};
    font-family: ${theme.fontFamilies.openSans};
    font-weight: ${theme.fontWeights.bold};
    @media (min-width: ${theme.breakpoints
        .sm}) and (max-width: ${isUnderLargeBreakpoint
        ? '1440px'
        : theme.breakpoints.md}) {
      width: 245px;
      margin-left: auto;
      margin-right: auto;
    }
    @media (min-width: ${theme.breakpoints.sm}) {
      width: 245px;
    }
  `}
`;
export const SelectedDesktopMenu = styled.ul<{ isAside?: boolean }>`
  display: flex;
  align-items: center;
  justify-self: end;

  list-style: none;

  li {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  ${({
    isAside,
    theme: {
      components: { header, navigationMenu },
    },
  }) =>
    css`
      gap: ${navigationMenu.gap};

      @media (max-width: ${header.breakpoint}) {
        grid-row: 1;
        grid-column: 3;
        margin-right: ${isAside ? '0' : navigationMenu.marginRight};
        display: none;
      }
    `}

  svg {
    cursor: pointer;
    transition: color 0.2s;
    color: ${({ isAside, theme: { colors } }) =>
      isAside ? colors.white : 'inherit'};

    &:hover {
      color: ${({ theme }) => theme.colors.primary};
    }
  }
`;

export const MobileMenu = styled(SelectedDesktopMenu)`
  display: flex;

  ${({
    isAside,
    theme: {
      components: { header },
    },
  }) =>
    !isAside &&
    css`
      display: none;

      @media (max-width: ${header.breakpoint}) {
        display: flex;
      }
    `}
`;
